const SEVERITY_STYLES = {
  low: "bg-gray-100 text-gray-600 border-gray-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  high: "bg-orange-100 text-orange-700 border-orange-200",
  critical: "bg-red-100 text-red-700 border-red-200",
};

export const SeverityBadge = ({ severity }) => (
  <span
    data-testid={`severity-badge-${severity}`}
    data-severity={severity}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide ${
      SEVERITY_STYLES[severity] || SEVERITY_STYLES.low
    }`}
  >
    {severity}
  </span>
);
